// Mock data for Lions Unleashed

export const teamMembers = [
  {
    id: 1,
    name: "Wesley Ramjeet",
    role: "Trustee",
    image: "https://customer-assets.emergentagent.com/job_pride-support/artifacts/2gm0gk78_Facetune_20-05-2025-14-41-56.jpeg",
    linkedin: "https://www.linkedin.com/in/wesley-ramjeet/",
    twitter: "https://x.com/wramjeet"
  },
  {
    id: 2,
    name: "Ashley Ramjeet",
    role: "Program Director",
    image: "https://customer-assets.emergentagent.com/job_lions-dashboard/artifacts/pg1c9376_ashramjeet-300x300.png",
    linkedin: "https://www.linkedin.com/in/ashley-ramjeet/"
  },
  {
    id: 3,
    name: "Shivam Yadav",
    role: "Development Director",
    image: "https://customer-assets.emergentagent.com/job_lions-dashboard/artifacts/vo05tkmu_1723441102789.jpg",
    linkedin: "https://www.linkedin.com/in/shivam-yadav-professional/"
  },
  {
    id: 4,
    name: "Nicole Maini",
    role: "Community Outreach Director",
    image: "https://businesscenter.wpmudev.host/wp-content/uploads/2020/07/0-150x150.jpg",
    linkedin: "https://www.linkedin.com/in/nicole-maini-193a92146/"
  },
  {
    id: 5,
    name: "Candace Nepal",
    role: "Assistant Treasurer",
    image: "https://businesscenter.wpmudev.host/wp-content/uploads/2019/11/candaceN4-1-150x150.png",
    linkedin: "https://www.linkedin.com/in/candace-nepal-17aa99103/"
  },
  {
    id: 6,
    name: "Amrita Narine",
    role: "Director",
    image: "https://customer-assets.emergentagent.com/job_lions-dashboard/artifacts/s90xsttm_1745360635948.jpg",
    linkedin: "#"
  },
  {
    id: 7,
    name: "Ravi Singh",
    role: "Board Advisor",
    image: "https://customer-assets.emergentagent.com/job_lions-dashboard/artifacts/afu8pa8i_ravi-singh-300x300.png",
    linkedin: "https://www.linkedin.com/in/ravi-singh-235b0171/"
  },
  {
    id: 8,
    name: "Nazreen Ghafoerkhan",
    role: "Board Advisor",
    image: "https://customer-assets.emergentagent.com/job_69ab5d25-c287-408f-a49d-e502a7f317ab/artifacts/017xkdnl_naz.jpeg",
    linkedin: "https://www.linkedin.com/in/ghafoerkhan-nazreen-67b8b385/"
  },
  {
    id: 9,
    name: "Vanessa Nank",
    role: "Director",
    image: "https://customer-assets.emergentagent.com/job_lions-dashboard/artifacts/pcth5wec_Vanessa%20Nank%27s%20Headshot%20%281%29.jpg",
    linkedin: "#"
  },
  {
    id: 10,
    name: "Kevin Castro",
    role: "Director",
    image: "https://customer-assets.emergentagent.com/job_lions-dashboard/artifacts/g8hctmt0_kevin-castro.png",
    linkedin: "#"
  },
  {
    id: 11,
    name: "Jyoti Hardat",
    role: "Marketing/PR",
    image: "https://customer-assets.emergentagent.com/job_lions-dashboard/artifacts/vo03dwa9_IMG_5527.JPEG",
    linkedin: "https://www.linkedin.com/in/jyotihardat"
  }
];

export const mentors = [
  {
    id: 1,
    name: "Andrew Ashby",
    image: "https://customer-assets.emergentagent.com/job_69ab5d25-c287-408f-a49d-e502a7f317ab/artifacts/yrhpavgt_IMG_3648.jpeg",
    linkedin: "https://www.linkedin.com/in/andrew-ashby-2b82b4"
  },
  {
    id: 2,
    name: "Rob Reid",
    image: "https://businesscenter.wpmudev.host/wp-content/uploads/2019/12/robreidpng.png"
  },
  {
    id: 3,
    name: "Sonaly Aditya",
    image: "https://businesscenter.wpmudev.host/wp-content/uploads/2019/12/sonalyapng.png"
  },
  {
    id: 4,
    name: "Pialy Aditya",
    image: "https://businesscenter.wpmudev.host/wp-content/uploads/2019/12/pialya.png"
  },
  {
    id: 5,
    name: "Jabili Kandula",
    image: "https://customer-assets.emergentagent.com/job_pixel-perfect-132/artifacts/1vis2hba_Screenshot%202025-12-03%20154920.png"
  },
  {
    id: 6,
    name: "Denny Mendez",
    image: "https://customer-assets.emergentagent.com/job_lions-dashboard/artifacts/o26wn60e_denny%20mendez.jpg"
  },
  {
    id: 7,
    name: "Jyoti Hardat",
    image: "https://customer-assets.emergentagent.com/job_lions-dashboard/artifacts/vo03dwa9_IMG_5527.JPEG"
  },
  {
    id: 8,
    name: "Heema Harrydyal",
    image: "https://customer-assets.emergentagent.com/job_69ab5d25-c287-408f-a49d-e502a7f317ab/artifacts/htcn0azh_IMG_3459.jpeg",
    linkedin: "https://www.linkedin.com/in/heema-harrydyal-5a810583"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Uotam Heeralall",
    role: "Student at Stony Brook University",
    image: "https://customer-assets.emergentagent.com/job_pixel-perfect-132/artifacts/yfi743je_Screenshot%202025-12-03%20154445.png",
    quote: "Lions Unleashed has been a tremendous supporter of both my academic and professional endeavors. Through their support, I am able to expand my academic knowledge in the sciences at Stony Brook University, the flagship institution known for its distinguished research program. This opportunity not only enriched my understanding of scientific principles but also provided a solid foundation for my professional growth through valuable work experiences. I am forever grateful for all of the opportunities that Lions Unleashed has provided me, and I am excited to continue growing with them."
  }
];

export const sponsors = [
  {
    id: 1,
    name: "The Agency",
    logo: "https://businesscenter.wpmudev.host/wp-content/uploads/2019/11/Agency1-scaled.png",
    website: "https://theagencyonline.com"
  },
  {
    id: 2,
    name: "MD Logic Wellness",
    logo: "https://customer-assets.emergentagent.com/job_pixel-perfect-132/artifacts/8u9obm11_pos%20logo.png",
    website: "https://mdlogichealth.com"
  },
  {
    id: 3,
    name: "PPMT Strategic Group",
    logo: "https://businesscenter.wpmudev.host/wp-content/uploads/2019/10/ppmt-logo-7252019.png",
    website: "https://ppmtgroup.com"
  }
];

export const donors = [
  "Bryan S De La Cruz",
  "Charities Aid Foundation America",
  "Chiawei Fang",
  "Cristian Mieses",
  "Dameury Pena Sanchez",
  "Daniel Castillo",
  "Diego Castillo",
  "Domingo Acevedo",
  "Dominican Equities LLC",
  "Elier Hernandez",
  "F J Sports Management LLC",
  "Francisco Perez",
  "Huascar Brazoban",
  "Jefry Rodriguez",
  "Jose Caballero",
  "Jose Cisnero",
  "Juan Minaya",
  "Kervin Castro Reina",
  "Lisbeth Faneytt",
  "Major League Baseball",
  "MD Logic Wellness",
  "Miguel Sanchez",
  "Rafael Devers",
  "Raul Alcantara",
  "Raynel Espinal Rodriguez",
  "Sandro Fabian",
  "Steward Berroa Gallatte",
  "Warner Madrigal"
];

export const countries = [
  "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda",
  "Argentina", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados",
  "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana",
  "Brazil", "British Virgin Islands", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi",
  "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Republic", "Chad", "Chile", "China Mainland",
  "Colombia", "Comoros", "Congo-Brazzaville", "Congo-Kinshasa", "Cook Islands", "Costa Rica", "Cote d'Ivoire",
  "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia",
  "Falkland Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "Gabon", "Gambia",
  "Georgia", "Germany", "Ghana", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala",
  "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia",
  "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya",
  "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia",
  "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macedonia", "Madagascar", "Malawi", "Malaysia",
  "Maldives", "Mali", "Malta", "Martinique", "Mauritania", "Mauritius", "Mexico", "Micronesia",
  "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia",
  "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria",
  "Niue", "Norfolk Island", "North Korea", "Norway", "Oman", "Pakistan", "Palau", "Palestine",
  "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar",
  "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Samoa", "San Marino",
  "São Tomé and Príncipe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone",
  "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea",
  "South Sudan", "Spain", "Sri Lanka", "St. Vincent and the Grenadines", "Sudan", "Suriname",
  "Swaziland", "Sweden", "Switzerland", "Syria", "Tajikistan", "Tanzania", "Thailand",
  "The United Arab Emirates", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey",
  "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Kingdom", "United States of America",
  "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Wallis and Futuna Islands",
  "Western Sahara", "Yemen", "Zambia", "Zimbabwe"
];

export const educationLevels = [
  "High School",
  "Associate's Degree",
  "Bachelor's Degree",
  "Graduate or Professional Degree",
  "Some College",
  "Other",
  "Prefer Not To Say",
  "Not Applicable"
];